/**
 * GENERATED BY KRPC GEN - LESS MODIFY BY HAND
 * eventtrack-service.ts  2025-06-05T09:42:57+08:00
 */
import type { R, RpcService, MethodConfig as M } from 'krpc-base'

import type { EventTrackReq } from './event-tracking-dto'

const _ = 'EventTrack/'

export class EventTrackService {
  constructor(readonly r: RpcService) {}
  // 事件上报
  track(d: EventTrackReq, m?: M): R<boolean> {
    return this.r.async(_ + 'track', d, m)
  }
}
